export enum EIntegrationConnectionType {
  FormulatrixIntegrationService,
  RestApi,
}

export const integrationConnectionTypeDropdown = [
  EIntegrationConnectionType[EIntegrationConnectionType.FormulatrixIntegrationService],
  EIntegrationConnectionType[EIntegrationConnectionType.RestApi],
];